import {
    type AptosFloorPriceEvent,
    type AptosListingEvent,
    type AptosTransfer,
} from '@app/client/common/structs/websockets/daas/events/multichain/aptos';
import {
    type EVMFloorPriceEvent,
    type EVMListingEvent,
    type EVMSaleEvent,
    type EVMTransfer,
} from '@app/client/common/structs/websockets/daas/events/multichain/evm';

import { type DaasActivityFeedEventType } from '../activity';

export enum YacsTopicKey {
    subscribe = 'subscribeToTopic',
    unsubscribe = 'unsubscribeFromTopic',
}

export enum YacsTopicTypes {
    Transfer = 'eth_raw_transfer',
    Sale = 'eth_sale_event',
    FloorPrice = 'eth_floor_price_event',
    Listing = 'eth_listing_event',
    Bid = 'eth_bid_event',
}

export enum YacsMultichainTopicTypes {
    listing = 'listing',
    floorprice = 'floorprice',
    sale = 'sale',
    transfer = 'transfer',
}
export enum YacsMultichainEventTypes {
    transferEvent = 'transferEvent',
    listingEvent = 'listingEvent',
    saleEvent = 'saleEvent',
    floorpriceEvent = 'floorpriceEvent',
}

export type FloorpriceEvent = EVMFloorPriceEvent | AptosFloorPriceEvent;
export type ListingEvent = EVMListingEvent | AptosListingEvent;
export type SaleEvent = EVMSaleEvent;
export type TransferEvent = EVMTransfer | AptosTransfer;

export interface MappedYacsEvents {
    floorpriceEvent: FloorpriceEvent;
    transferEvent: TransferEvent;
    listingEvent: ListingEvent;
    saleEvent: SaleEvent;
}

export type YacsEventData = { [Property in keyof MappedYacsEvents]?: MappedYacsEvents[Property] };

export type MultichainEventSubscription = {
    listener: YacsMultichainEventTypes;
    emitter: MultichainEventEmitter;
};

export type MultichainEventEmitter = { name: YacsMultichainTopicTypes; chain?: string; specifier?: string };

export type MultiChainEvents = { [key in YacsMultichainEventTypes]: MultichainEventSubscription };
export type EventSubscription = {
    listener: DaasActivityFeedEventType;
    emitter: {
        name: string;
        values: string[];
    };
};
